import e, { useRef as b, useState as p, useEffect as v } from "react";
import N from "classnames";
import { Label as x } from "../Label/Label.js";
import t from "./quantitySelector.module.scss.js";
function F({
  label: c,
  max: r,
  min: l,
  defaultQuantity: a,
  step: u = 1,
  onChange: n,
  height: y = 40,
  fontSize: d = 20,
  textColor: f = "#FFF",
  backgroundColor: _ = "#242323",
  borderColor: S = "#777777"
}) {
  const o = b(!1), [i, m] = p(a ?? 0);
  v(() => {
    o.current && (n == null || n(i));
  }, [i]);
  const E = () => {
    o.current = !0, m((s) => Math.min(s + u, r ?? 1 / 0));
  }, q = () => {
    o.current = !0, m((s) => Math.max(s - u, l ?? -1 / 0));
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "quantity-selector",
      className: N({
        [t.quantitySelector]: !0
      }),
      style: {
        "--height": `${y}px`,
        "--text-color": f,
        "--background-color": _,
        "--border-color": S,
        "--fontSize": `${d}px`
      }
    },
    /* @__PURE__ */ e.createElement(
      "button",
      {
        className: t.quantitySelector__decrease,
        type: "button",
        onClick: () => q()
      },
      "-"
    ),
    /* @__PURE__ */ e.createElement("div", { className: t.quantitySelector__display }, /* @__PURE__ */ e.createElement("div", { className: t.quantitySelector__quantity }, i), r && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: t.quantitySelector__divider }, "/"), /* @__PURE__ */ e.createElement("div", { className: t.quantitySelector__max }, r))),
    /* @__PURE__ */ e.createElement(
      "button",
      {
        className: t.quantitySelector__increase,
        type: "button",
        onClick: () => E()
      },
      "+"
    )
  );
}
function I(c) {
  const {
    label: r,
    textColor: l
  } = c, a = /* @__PURE__ */ e.createElement(F, { ...c });
  return r !== void 0 ? /* @__PURE__ */ e.createElement(
    x,
    {
      text: r,
      preventDefault: !0,
      textColor: l ?? "#FFF"
    },
    /* @__PURE__ */ e.createElement("div", { className: t.quantitySelector__labelWrapper }, a)
  ) : a;
}
export {
  I as QuantitySelector,
  F as QuantitySelectorRoot
};
//# sourceMappingURL=QuantitySelector.js.map
